import { render, staticRenderFns } from "./PoiMiniCardContent.vue?vue&type=template&id=a3df8280&"
import script from "./PoiMiniCardContent.vue?vue&type=script&lang=ts&"
export * from "./PoiMiniCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports